<template>
    <okraina-view :class="'okraina-v-pi'" @refresh="refresh" :hideMenu="true" :contentHorizontalPadding="0">
        <template v-slot:header>
            <h1>
                Пригласить друга
            </h1>
        </template>

        <template v-slot:content>

            <!--Индикатор загрузки-->
            <transition>
                <okraina-loader-page v-show="loading || !canShow" />
            </transition>

            <!-- Ошибка загрузки -->
            <template v-if="loadingError">
                <okraina-illustration :picture="imageError" caption="Ошибка загрузки данных.">
                    <div class="btn btn1 slim" @click="retryLoad">
                        Повторить
                    </div>
                </okraina-illustration>
            </template>

            <template v-if="!loading && !loadingError && canShow">

                <div class="block">

                    <div class="spacer"></div>

                    <div class="description">
                        <p>Шаг 1: Скопируйте промо-код из вашего личного кабинета.</p>
                        <p>Шаг 2: Отправьте промо-код в мессенджер или на электронную почту друга</p>
                        <p>Шаг 3: Друг оформляет заказ, вводит промо-код  и получает {{ this.bonusRegister }} бонусных баллов, а вы – {{ this.bonusAffiliate }} баллов</p>
                        Подробные условия читайте в <a href="/personal/invite/terms/" @click.prevent="goToTerms">Правилах программы</a>

                    </div>
                    <div class="promo">
                        <h2>Ваш промокод</h2>
                        <okraina-control-input v-model="this.promo" />
                    </div>
                    <div class="links-wrap">
                        <h2>Поделиться</h2>

                        <div class="links">
                            <div class="link" @click="copy">
                                <span class="icon fi fi-copy"></span>
                            </div>
                            <div class="link" @click="share" v-if="this.isNative">
                                <span class="icon fi fi-share"></span>
                            </div>
                        </div>
                    </div>

                    <h2>Пригласить друзей по электронной почте</h2>

                    <okraina-control-textarea label="Кому" :required="true" v-model="values.EMAILS"
                        v-model:error="errors.EMAILS" v-model:valid="valids.EMAILS" :rows=2 placeholder="E-mail"
                        description="E-mail адреса друзей через запятую (не более 10 адресатов)" />

                    <div class="btn btn-block btn1 btn-send" v-ripple :class="[saving ? 'wait' : '']" @click="send">
                        Отправить
                        <div v-if="saving" class="btn-loader"></div>
                    </div>

                </div>

                <div class="history">
                    <h2>Приглашённые друзья</h2>

                    <okraina-personal-invite-history v-if="!this.refreshing" ref="history" />
                </div>


            </template>

        </template>
    </okraina-view>
</template>


<script>
import okrainaView from "@/components/view2.vue"
import okrainaLoaderPage from "@/components/loader.page.vue"
import okrainaIllustration from "@/components/illustration.vue";
import okrainaControlTextarea from "@/components/controls/textarea.vue";
import okrainaControlInput from "@/components/controls/input.vue";
import okrainaPersonalInviteHistory from '@/components/personal/invite.history.vue'

import imageErrorPath from "@/assets/images/error.svg";

import rest from "@/plugins/rest";
import bus from "@/plugins/bus";
import meta from "@/plugins/meta";
import metaTemplates from "@/plugins/meta/personal.invite.js";

import { mapGetters } from "vuex";

export default {
    name: "okraina-v-personal-invite",
    components: {
        okrainaView,
        okrainaLoaderPage,
        okrainaIllustration,
        okrainaControlTextarea,
        okrainaControlInput,
        okrainaPersonalInviteHistory
    },
    data() {
        return {
            loading: false,
            loadingError: false,
            refreshing: false,
            saving: false,
            link: "",
            promo:"",
            values: {
                TEXT: "",
                EMAILS: ""
            },
            errors: {},
            valids: {},

            imageError: imageErrorPath,
            canShow: false
        };
    },
    computed:{
        ...mapGetters({
            isNative: "isNativePlatform",
            siteSettings: "getSiteSettings"
        }),
        bonusRegister (){
            return this.siteSettings.COUNT_BONUS_AFTER_REGISTRATION
        },
        bonusAffiliate (){
            return this.siteSettings.COUNT_BONUS_FRIEND
        },
    },
    methods: {

        /**
         * Загружает данные
         */
        loadData(resolve = false) {

            if (this.loading) {
                return;
            }
            this.loading = resolve == false ? true : false;

            rest
                .call("invites.send.info", {
                    method: "post",
                    data: {
                    },
                })
                .then((data) => {
                    this.loadingError = !data.SUCCESS;
                    if (data.SUCCESS) {

                        this.values.TEXT = data.LETTER_TEXT;
                        this.values.EMAILS = "";
                        this.link = data.LINK;
                        this.promo = data.PROMO;

                        this.resetValues();
                    } else {
                        //показываем сообщение об ошибке
                        bus.emit("OKRAINA_MESSAGE_E_SHOW", { message: data.ERROR_TEXT });
                    }
                })
                .finally(() => {
                    this.refreshing = false;
                    this.loading = false;
                    if (resolve) {
                        resolve();
                    }
                });

        },

        /**
         * Сброс полей
         */
        resetValues() {

            for (var code in this.values) {
                this.valids[code] = true;
                this.errors[code] = false;
            }
        },

        /**
         * Повторная попытка загрузки
         */
        retryLoad() {
            this.loadData();
        },

        /**
         * Перезагрузка экрана
         */
        refresh(resolve) {
            this.refreshing = true;
            this.loadData(resolve);
        },

        /**
         * Переход к правилам
         */
        goToTerms() {
            this.$router.push({ path: "/personal/invite/terms/" });
        },

        /**
         * Поделиться ссылкой
         */
        share() {
            
            let text = "";
            if(this.values.TEXT) {
                //удаление html-тегов
                text = this.values.TEXT.replace(/(<([^>]+)>)/ig, '')
            }

            bus.emit("OKRAINA_APP_E_SHARE", {
                title: 'Поделиться',
                text: text,
                url: this.link,
                dialogTitle: 'Поделиться',
            });

        },

        /**
         * Скопировать в буфер
         */
        copy() {

            bus.emit("OKRAINA_CLIPBOARD_E_WRITE", {
                text: this.promo,
                successMessage: 'Промокод  скопирован.',
            });


        },

        /**
         * Отправка приглашений
         */
        send() {

            //првоерка введённых данных
            if (!this.checkValues()) {
                return;
            }

            if (this.saving) {
                return;
            }
            this.saving = true;

            rest
                .call("invites.send", {
                    method: "post",
                    data: {
                        EMAILS: this.values.EMAILS,
                    },
                })
                .then((data) => {
                    if (data.ERROR_TEXT) {
                        //показываем сообщение об ошибке
                        bus.emit("OKRAINA_MESSAGE_E_SHOW", { message: data.ERROR_TEXT });
                    } else {
                        bus.emit("OKRAINA_MESSAGE_E_SHOW", { message: "Приглашения отправлены.", type: "success" });

                        //перезагружаем историю
                        this.$refs.history.reload();

                    }
                })
                .finally(() => {
                    this.saving = false
                });


        },

        /**
         * Проверяет значения
         */
        checkValues(showErrors = true) {

            for (var code in this.values) {
                let error = !this.valids[code];
                //если нужно показать ошибки или если у поля нет ошибок
                if (showErrors || !error) {
                    this.errors[code] = error;
                }
            }

            for (var key in this.errors) {
                if (this.errors[key]) {
                    return false
                }
            }

            return true;
        },
    },

    created() {
        this.loadData();

        //задерживаем показ до завершения перехода на экран (чтобы анимация перехода без тормазов была)
        setTimeout(() => {
            this.canShow = true;
        }, 400);
    },

    /**
     * Обраотка переход входом на экран
     */
    beforeRouteEnter() {
        //запишем мета данные страницы
        meta.write(metaTemplates);
    },
}
</script>

<style lang="scss">
.okraina-v-pi {

    .block {
        padding: 0px 19px 20px;
        margin-bottom: 25px;
        background-color: var(--color-block-background);
    }

    .description {
        font-size: 12px;
        margin-bottom: 20px;
        color: var(--color-text-description);
        p{
            margin-bottom: 5px;
        }
    }

    .links {
        margin-bottom: 25px;

        &::after {
            content: "";
            display: block;
            clear: both;
        }


        .link {
            position: relative;
            float: left;
            width: 40px;
            height: 40px;
            border-radius: 50%;
            margin-right: 10px;
            background-color: rgba(var(--color-color1-rgb), 0.05);

            &:last-of-type {
                margin-right: 0px;
            }

            .icon {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                font-size: 17px;
                color: var(--color-color1);
            }
        }
    }

    .history {
        padding: 0px 19px;
    }


}
</style>